import { storage } from 'BASE/common/util/util.storage';
import * as apiProxy from 'BASE/common/util/util.apiProxy';
import * as loginUtil from 'BASE/common/login/login.util';
import _constant from 'BASE/common/lotteryConstant';
import { actionTypes } from 'BASE/store/types';
import { browser } from 'BASE/common/util/util.browser';
export const TokenVerifyResult = _constant.TokenVerifyResult;

export default {
    data: function () {
        return {
            LockRefreshToken: false,
            IgnoreRefreshActionList: [  //不會做RefreshToken的清單
                '/api/Token/Login',
                '/api/Token/Refresh',
                '/api/Wallet/GetWalletAmount',
                '/api/Bet/Record',
                '/api/ScheduleRecord/Search'
            ],
            TokenMsg: {
                Blacklist: "此次登录已被登出，请重新登录!",
                DifferentUser: "该账号有其他人登录，此次登录已被登出!",
                ChangePassword: "该账号已变更密码，请重新登录!",
                ForcedLogout: "该账号被强制登出，如有疑问请洽客服!"
            }
        };
    },
    methods: {
        responseMsg(type) {
            let _responseMsg = "";
            switch (type) {
                case TokenVerifyResult.BLACKLIST:
                    _responseMsg = this.TokenMsg.Blacklist;
                    break;
                case TokenVerifyResult.DIFFERENT_USER:
                    _responseMsg = this.TokenMsg.DifferentUser;
                    break;
                case TokenVerifyResult.CHANGE_PASSWORD:
                    _responseMsg = this.TokenMsg.ChangePassword;
                    break;
                case TokenVerifyResult.FORCED_LOGOUT:
                    _responseMsg = this.TokenMsg.ForcedLogout;
                    break;
            }
            return _responseMsg;
        },
        ajaxInit() {
            let _this = this;
            _this.ajaxSetup();
            _this.setPostJSON();
            _this.ajaxPrefilter();
            if(ENVIRONMENT.CORDOVA){
                _this.ajaxSetupCordova();
            }
            if(browser.isMobile) {
                _this.ajaxSetupMobile();
            }
        },
        ajaxSetup() {
            let _this = this;
            // 修改預設選項
            $.ajaxSetup({
                error: function (jqXHR, textStatus, errorThrown) {
                    // 已在維護頁、IP限制頁就不再跳轉避免無限跳轉  (配置IPRestricted主要是給Cordova使用，網頁版的都會由網管那直接轉跳)
                    let _path = _this.$route.path;
                    if (_path.indexOf('/Offline') != -1 || _path.indexOf('/IPRestricted') != -1) {
                        return;
                    }

                    let _ajaxUrl = this.url;

                    //判別當api是定期去server取值的如定期取餘額，當發生ajax錯誤時只處理系統維護、登入權限已失效其他狀況都不處理
                    var offline = jqXHR.responseJSON && jqXHR.responseJSON.OfflineEndTime;
                    if (!offline) {
                        if (_this.IgnoreRefreshActionList.find((item) => _ajaxUrl.indexOf(item) != -1) && (jqXHR.status != 403 && jqXHR.status != 401)) {
                            return;
                        }
                    }

                    switch (jqXHR.status) {
                        //Safari瀏覽器被取消時會發送0
                        //case 0:
                        //    _this.$router.refreshTo(`/ErrorMsg?Msg=jqXHR.status 错误代码:0`);
                        //    break;
                        case 401:
                        case 403:
                            //Time out改定期檢測，這邊就不再重覆處理
                            //只處理額外添加的事件
                            if (jqXHR.responseText) {
                                loginUtil.Logout();
                                _this.$store.dispatch(actionTypes.USER_INFO_INIT);

                                if (jqXHR.responseText.indexOf('IP_restricted') != -1) {
                                    _this.$router.refreshTo('/IPRestricted');
                                }
                                else {
                                    _this.$router.refreshTo(`/ErrorMsg?Msg=${_this.responseMsg(parseInt(jqXHR.responseText))}`);
                                }
                            }

                            break;

                        case 500:
                            _this.$router.push('/ErrorMsg');
                            break;

                        case 503:
                            if (jqXHR.responseJSON && jqXHR.responseJSON.OfflineEndTime) {
                                loginUtil.Logout();
                                _this.$store.dispatch(actionTypes.USER_INFO_INIT);
                                _this.$router.refreshTo(`/Offline?EndTime=${jqXHR.responseJSON.OfflineEndTime}`);
                            }
                            break;
                    }
                }
            });
        },
        ajaxSetupCordova(){                
            let appBundleVersion = window.localStorage["APP_VERSION"] + ", " + (window.localStorage["BUNDLE_VERSION"] ? window.localStorage["BUNDLE_VERSION"] : "NA");
            $.ajaxSetup({
                headers: { 'X-AppBundleVersion': appBundleVersion, 'X-DeviceUUID':window.localStorage["DEVICE_UUID"] }
            });
        },
        ajaxSetupMobile(){
            $.ajaxSetup({
                headers: { 'X-Mobile': "1" }
            });
        },
        setPostJSON() {
            // 增加Json Post功能
            $.postJSON = function (url, data, success, args) {
                args = $.extend({
                    url: url,
                    type: 'POST',
                    data: JSON.stringify(data),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    async: true,
                    success: success
                }, args);
                return $.ajax(args);
            };
        },
        ajaxPrefilter() {
            let _this = this;
            //在每一個Ajax要求被傳送以及被 $.ajax()處理前執行
            $.ajaxPrefilter(function (options, originalOptions, jqXHR) {

                // api url
                options.url = apiProxy.urlCombine(options.url);

                let _accessToken = storage.local.get(storage.keys.ACCESS_TOKEN);
                if (_accessToken) {
                    jqXHR.setRequestHeader('Authorization', `Bearer ${_accessToken}`);

                    // 忽略清單不刷新token
                    for (let i = 0; i < _this.IgnoreRefreshActionList.length; i++) {
                        if (originalOptions.url.startsWith(_this.IgnoreRefreshActionList[i])) {
                            return;
                        }
                    }

                    let _expiresTime = storage.local.get(storage.keys.EXPIRES_TIME);
                    // token到期時間小於5分鐘則更新
                    if (!_this.LockRefreshToken && _expiresTime && new Date(new Date().getTime() + 5 * 60 * 1000) >= parseInt(_expiresTime)) {
                        //先鎖住避免同一個Connection多個ajax發送時，每個都重覆做RefreshToken
                        //同時刷新會造成RefreshToken在Redis已更新，除了第一個刷新的ajax外後續非同步的都是使用到舊的RefreshToken，Redis會比對不到造成Timeout
                        _this.LockRefreshToken = true;
                        $.getJSON("/api/Token/Refresh", (result) => {
                            //Token內並無包含userName、nickName，需將原先的取出變更時效
                            let _userName = storage.local.get(storage.keys.USER_NAME);
                            let _nickName = storage.local.get(storage.keys.NICK_NAME);
                            loginUtil.Login(result, _userName, _nickName);

                            _this.$store.dispatch(actionTypes.USER_INFO_INIT);
                        }).always(function () {
                            //執行完不管成功失敗都解鎖
                            _this.LockRefreshToken = false;
                        });
                    }
                }
            });
        },
        checkTimeOut() {
            let _this = this;
            let _expiresTime = storage.local.get(storage.keys.EXPIRES_TIME);
            if (_expiresTime) {
                if (new Date().getTime() > _expiresTime) {
                    //延後2秒才刪除做登出資料清除，避免開多各視窗另外的還沒檢測到storage值就被清除
                    setTimeout(function () {
                        loginUtil.Logout();
                        _this.$store.dispatch(actionTypes.USER_INFO_INIT);
                        if (_this.$route.query.page != "speedtest") {
                            _this.$router.refreshTo('/Timeout');
                        }
                    }, 2000);
                }
            }
        }
    },
    created() {
        this.ajaxInit();
        let _timeOut = setInterval(this.checkTimeOut, 1000);  //每秒檢查Time out狀況
    },
}